import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const InfoDeliveryTableHead = (props) => {
  const { t } = useTranslation();

  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: 'reference',
      label: t('Delivery.table.head.reference'),
      align: 'left',
    },
    {
      id: 'client.user.firstName',
      label: t('Delivery.table.head.client'),
      align: 'left',
    },
    { id: 'products', label: t('Delivery.table.head.products'), align: 'left' },
    {
      id: 'status.description',
      label: t('Delivery.table.head.status'),
      align: 'left',
    },
    {
      id: 'createdAt',
      label: t('Delivery.table.head.createdat'),
      align: 'left',
    },
    {
      id: 'deliveryDatetime',
      label: t('Delivery.table.head.duedate'),
      align: 'left',
    },
    {
      id: 'shapyer',
      label: t('Delivery.table.head.shapyer'),
      align: 'left',
    },
    {
      id: 'orderCost.productsCost',
      label: t('Delivery.table.head.ordervalue'),
      align: 'left',
    },
    { id: 'invoice', label: t('Delivery.table.head.invoice'), align: 'right' },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding="center"
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              disabled={true}>
              <strong>{headCell.label}</strong>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

InfoDeliveryTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
